export type SessionUser = {
  userId?: string;
  role?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
};

export type LoginSuccessPayload = {
  token?: string;                 // legacy name (access token)
  accessToken?: string;           // preferred name
  refreshToken?: string | null;   // present for mobile; ignored on web
  userId?: string;
  role?: string;
  email?: string;
  phone?: string;                 // e.g. "+91 9876543210" or "9876543210"
};

const K = { access: "authToken", user: "authUser" } as const;

export const session = {
  getAccess(): string | null { return sessionStorage.getItem(K.access); },
  getUser(): SessionUser | null {
    const raw = sessionStorage.getItem(K.user);
    return raw ? JSON.parse(raw) as SessionUser : null;
  },
  save({ accessToken,  user }: { accessToken: string; user?: SessionUser }) {
    sessionStorage.setItem(K.access, accessToken);
    if (user) sessionStorage.setItem(K.user, JSON.stringify(user));
  },
  clear() {
    sessionStorage.removeItem(K.access);
    sessionStorage.removeItem(K.user);
    try { window.dispatchEvent(new CustomEvent("auth:logout")); } catch {}
  },
};
